import React from 'react';

const IsPaid = ({ rowData }) => {
    return (
        <span className={rowData.is_paid ? "text-green-500" : "text-red-500"}>
            {rowData.is_paid ? 
            "پرداخت شده" :
            "پرداخت نشده"
            }
        </span>
    );
}

export default IsPaid;
